import OperatorIcon from './OperatorIcon'

export default OperatorIcon
